import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowUpRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const res = await register(form.name, form.email, form.password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Welcome to the house");
      navigate("/account", { replace: true });
    } else {
      toast.error(res.error);
    }
  };

  return (
    <main className="page">
      <div className="page-head">
        <span className="eyebrow">Join the house</span>
        <h1>
          Create <em>account.</em>
        </h1>
      </div>
      <form onSubmit={submit} className="checkout-form">
        <div className="form-field">
          <label>Full name</label>
          <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="register-name-input" />
        </div>
        <div className="form-field">
          <label>Email</label>
          <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} autoComplete="email" data-testid="register-email-input" />
        </div>
        <div className="form-field">
          <label>Password (min 6 characters)</label>
          <input required type="password" minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} autoComplete="new-password" data-testid="register-password-input" />
        </div>
        <button className="btn btn-primary" type="submit" disabled={submitting} data-testid="register-submit-button">
          {submitting ? "Creating…" : "Create account"} <ArrowUpRight size={14} />
        </button>
        <p style={{ color: "var(--muted)", fontSize: 13 }}>
          Already have an account?{" "}
          <Link to="/login" className="text-link" style={{ padding: 0 }} data-testid="go-to-login-link">
            Sign in
          </Link>
        </p>
      </form>
    </main>
  );
}
